import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { selectSearchTerm } from "../../features/searchSlice";

export const loadAllPostPreview = createAsyncThunk(
  "postPreview/loadAllPostPreview",
  async (subreddits) => {
    const response = await fetch(`https://www.reddit.com/r/${subreddits}.json`);
    const json = await response.json();
    return json.data.children;
  }
);

export const postPreviewSlice = createSlice({
  name: "postPreview",
  initialState: {
    post: [],

    isLoadingPostPreview: false,
    failedToPostPreview: false,
  },

  extraReducers: {
    [loadAllPostPreview.pending]: (state, action) => {
      state.isLoadingPostPreview = true;
      state.failedToPostPreview = false;
    },
    [loadAllPostPreview.fulfilled]: (state, action) => {
      state.isLoadingPostPreview = false;
      state.failedToPostPreview = false;

      state.post = action.payload;
    },

    [loadAllPostPreview.rejected]: (state, action) => {
      state.isLoadingPostPreview = false;
      state.failedToPostPreview = true;
    },
  },
});

export const isLoadingPosts = (state) => state.postPreview.isLoadingPostPreview;

export const selectPostPreview = (state) => state.postPreview.post;

export const selectFilteredPost = (state) => {
  const allPost = selectPostPreview(state);
  const searchTerm = selectSearchTerm(state);
  if (searchTerm !== "") {
    return allPost.filter((post) =>
      post.data.title.toLowerCase().includes(searchTerm.toLowerCase())
    );
  } else {
    return allPost;
  }
};

export default postPreviewSlice.reducer;
